import {ClientType, getStoreName} from '@buncha/common/types/common';
import {Dimensions, StyleSheet} from 'react-native';
import React, {useCallback, useMemo} from 'react';

import {Analytics} from '@buncha/config/analytics/analytics';
import {BackHeaderLeft} from '@buncha/common/components/BackHeaderLeft';
import {CommonScreens} from '@buncha/common/navigation/types';
import {EventType} from '@buncha/config/analytics/type';
import {H4Text} from '../../../../components/core/text';
import {HBox} from '../../../../components/core/view';
import If from '@buncha/components/conditional/If';
import {MainScreens} from '@buncha/navigation/types';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {Touchable} from '@buncha/components/core/touchable';
import font from '@buncha/appStyles/style/font';
import {navigation} from '@buncha/config/navigation';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useColorThemeType} from '../../../../appStyles/hooks/theme';
import {useGetLocale} from '@buncha/localization/hooks';

interface B2BLocationInStoreProps {
  location?: string;
  storeId: number | undefined;
}

const B2BLocationInStore: React.FC<B2BLocationInStoreProps> = props => {
  const theme = useColorThemeType('main');
  const storeMapsString = useAppSelector(
    gState => gState.onboarding.constants?.B2B_STORE_MAPS,
  );
  const {body} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const storeMap = useMemo(() => {
    const storeMaps = storeMapsString ? JSON.parse(storeMapsString) : {};
    if (!props?.storeId) return '';
    return storeMaps[props?.storeId];
  }, [props?.storeId, storeMapsString]);

  const viewStoreMap = useCallback(() => {
    Analytics.eventWithProps('store map', {
      type: EventType.cta,
      client: ClientType.meijer,
      storeType: getStoreName(String(props?.storeId)),
      source: 'Item Detail Page',
    });
    navigation.navigate(MainScreens.Common, {
      screen: CommonScreens.ImagePreview,
      params: {imageUrl: storeMap, isMap: true},
    });
  }, [props?.storeId, storeMap]);

  return (
    <HBox style={[styles.container, {backgroundColor: theme?.text.blue[300]}]}>
      <BackHeaderLeft
        containerStyle={{backgroundColor: theme?.text.blue[300]}}
        iconColor={theme?.text.white[100]}
      />
      <Touchable
        onPress={viewStoreMap}
        style={[
          {backgroundColor: theme?.text.blue[300]},
          styles.touchContainer,
        ]}>
        <If condition={props?.location}>
          <HBox
            style={[
              styles.bodyContainer,
              {backgroundColor: theme?.text.blue[300]},
            ]}>
            <H4Text
              style={[styles.locationTypo, {color: theme?.text.white[100]}]}
              numberOfLines={1}>
              {body?.itemLocatedIn?.replace('{location}', props?.location)}
            </H4Text>
          </HBox>
        </If>
      </Touchable>
    </HBox>
  );
};

export default React.memo(B2BLocationInStore);

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: 'flex-start',
  },
  touchContainer: {
    width: Dimensions.get('screen').width - 50,
  },
  bodyContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    height: 35,
    padding: 5,
    paddingRight: 15,
    gap: 5,
  },
  locationTypo: {
    textAlign: 'center',
    fontFamily: font.fonts.muliBold,
  },
});
